import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from '../../../Auth/apiService';
import CargandoSpinner from "../../Utils/CargandoSpinner";
import SeccionPageHeader from "../../Utils/SeccionPageHeader";
import { useAuth } from '../../../Auth/AuthContext';
import { ConvertErrors422ToString } from '../../Utils/ConvertErrors422ToString';
import 'react-datepicker/dist/react-datepicker.css';



export default function EditarProcesoFirma() {
    const { procesoFirmaId } = useParams();
    const { token } = useAuth();
    
    const [cargando, setCargando] = useState(false);
    const today = new Date().toISOString().split('T')[0];
    const [actas, setActas] = useState([]);
    const [actasSinProceso, setActasSinProceso] = useState([]);
    const [mostrarActasSinProceso, setMostrarActasSinProceso] = useState(false);
    const [procesoFirma, setProcesoFirma] = useState(null);
    const [seleccionarTodo, setSeleccionarTodo] = useState(false);
    const [swalProps, setSwalProps] = useState({})
    
    const Mensaje = (title, text, icon) => {
        setSwalProps({
            show: true,
            title,
            text,
            icon, // 'success' or 'error'
        });
    };

    useEffect(() => {
        if (procesoFirmaId) {
            ConsultarProcesoFirma(procesoFirmaId);
        }
    }, [procesoFirmaId]);
    
    async function ConsultarProcesoFirma(procesoFirmaId) {
        setCargando(true);
        const data = { procesoFirmaId: procesoFirmaId };
        try {
            const response = await apiService.post('/bodega/consultarprocesofirma', data, token);
            if (response.status === 200) {
                setProcesoFirma(response.data.procesoFirma || null);
                setActas(response.data.actas || []);
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Consultar proceso firma', ConvertErrors422ToString(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Consultar proceso firma', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    
    async function ConsultarActasSinProceso() {
        setCargando(true);
        try {
            const response = await apiService.post('/bodega/consultaractasporidpersona', { idPersona: procesoFirma.proIdpersona }, token);
            if (response.status === 200) {
                setActasSinProceso(response.data.actas || []);
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Consultar actas', ConvertErrors422ToString(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Consultar actas', JSON.stringify(error.response.data));
            }else if(error.status === 404){
                setActasSinProceso([]);
                Mensaje('Consultar actas', 'No se encontraron actas sin proceso para esta persona.', 'info');
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }

    async function agregarActaAlProceso(idActa, idProcesoFirma) {
        setCargando(true);
        try {
            const response = await apiService.post('/bodega/agregaractaalprocesofirma', { idActa, idProcesoFirma }, token);
            if (response.status === 200) {
                await ConsultarProcesoFirma(procesoFirmaId);
                await ConsultarActasSinProceso();
                Mensaje('Agregar acta', 'Acta agregada al proceso de firma exitosamente.', 'success');
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Agregar acta', ConvertErrors422ToString(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Agregar acta', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }

    return (
        <div className="content-wrapper">
            <SeccionPageHeader
                title="Firma de actas"
                idCabezaFamilia="1"
                url="/bodega/ahe"
                nombreurl="AHE"
                nombreform="Firma de actas"
            />
            <CargandoSpinner Cargando={cargando} />
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary card-outline">
                                <div className="card-header">
                                    <h3 className="card-title">Proceso firmas</h3>
                                </div>
                                {procesoFirma && (
                                    <div className="card-body">
                                        <h5>Datos del Proceso de Firma</h5>
                                        <ul>
                                            <li><strong>ID:</strong> {procesoFirma.id || '-'}</li>
                                            <li><strong>proIdpersona:</strong> {procesoFirma.proIdpersona || '-'}</li>
                                            <li>
                                                <strong>Fecha de Creación:</strong> {
                                                    procesoFirma.proFecha && !isNaN(Date.parse(procesoFirma.proFecha))
                                                        ? procesoFirma.proFecha.split('T')[0]
                                                        : (procesoFirma.proFecha || '-')
                                                }
                                            </li>
                                            <li>
                                                <strong>Estado:</strong> {procesoFirma.proTerminado ? 'Finalizado' : 'Abierto'}
                                            </li>
                                        </ul>
                                    </div>
                                )}
                                {procesoFirma?.proIdpersona && <div className="card-body">
                                    <button
                                        className="btn btn-info"
                                        onClick={async () => {
                                            await ConsultarActasSinProceso();
                                        }}
                                        data-tooltip-id="tooltiparriba"
                                        data-tooltip-content="Ver listado de actas sin proceso"
                                    >
                                        Ver Actas Sin firmar
                                    </button>
                                </div>}
                                {actasSinProceso.length > 0 && 
                                    <div className="card-body">
                                        <h5>Actas sin Proceso</h5>
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Id</th>
                                                        <th>Fecha</th>
                                                        <th>Beneficiario</th>
                                                        <th>Tipo de Ayuda</th>
                                                        <th>Tipo de Entrega</th>
                                                        <th>Usuario</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {actasSinProceso.map((acta, idx) => (
                                                        <tr key={acta.id || idx}>
                                                            <td>{idx + 1}</td>
                                                            <td>{acta.id}</td>
                                                            <td>{acta.ate_fecha ? acta.ate_fecha.split('T')[0] : '-'}</td>
                                                            <td>{acta.beneficiario || acta.ate_idpersona || '-'}</td>
                                                            <td>{acta.tip_tipoahu || '-'}</td>
                                                            <td>{acta.tip_tipoentrega || '-'}</td>
                                                            <td>{acta.nombreusuario || '-'}</td>
                                                            <td>
                                                                <button
                                                                    className="btn btn-primary btn-sm"
                                                                    onClick={async () => {
                                                                        await agregarActaAlProceso(acta.id, procesoFirma.id);
                                                                    }}
                                                                >
                                                                    Agregar al proceso firmas
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    }
                                <div className="card-body">
                                    {actas.length === 0 ? (
                                        <div className="text-center text-muted">No hay actas para mostrar.</div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Id Atención</th>
                                                        <th>Id Persona</th>
                                                        <th>Id Usuario Entrega</th>
                                                        <th>Id Carpeta Img</th>
                                                        <th>Id Proceso Firma</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {actas.map((acta, idx) => (
                                                        <tr key={acta.id || idx}>
                                                            <td>{idx + 1}</td>
                                                            <td>{acta.actIdatencion || '-'}</td>
                                                            <td>{acta.actIdpersona || '-'}</td>
                                                            <td>{acta.actIdusuarioentrega || '-'}</td>
                                                            <td>{acta.actIdcarpetasimg || '-'}</td>
                                                            <td>{acta.actProcesofirmasid || '-'}</td>
                                                            <td>
                                                                <button className="btn btn-sm btn-secondary" onClick={() => 
                                                                    Mensaje('Sacar del proceso', 'Funcionalidad en desarrollo.', 'info')
                                                                }
                                                                    >Sacar del proceso</button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>
                <SweetAlert2
                    {...swalProps}
                    didClose={() => setSwalProps({})}
                    onConfirm={() => {
                        if (swalProps.icon === 'success') {
                            setSwalProps({});
                            irAResultado();
                        } else {
                            setSwalProps({});
                        }
                    }}
                />
                <Tooltip id="tooltiparriba" place="right"/>  
            </section>
        </div>
    );

}